import { NgModule } from '@angular/core';
import { FormErrorDirective } from './form-error.directive';
import { FormErrorMessageComponent } from './form-error-message.component';

const COMPONENTS = [
  FormErrorDirective,
  FormErrorMessageComponent,
];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class FormErrorModule {}
